import { createReducer } from 'redux-act';
import { TLegacyErrors } from '@alycecom/services';

import { claimRequest, claimSuccess, claimFail, setShowResubscribeModal } from './claim.actions';

export interface IClaimState {
  isLoading: boolean;
  isClaimed: boolean;
  showResubscribeModal: boolean;
  redirectUrl: string;
  errors: TLegacyErrors;
}

export const initialState: IClaimState = {
  isLoading: false,
  isClaimed: false,
  showResubscribeModal: false,
  redirectUrl: '',
  errors: {},
};

const reducer = createReducer<IClaimState>({}, initialState);

reducer
  .on(claimRequest, state => ({
    ...state,
    isLoading: true,
  }))
  .on(claimSuccess, (state, payload) => ({
    ...state,
    isClaimed: true,
    showResubscribeModal: false,
    redirectUrl: payload.redirectUrl,
    isLoading: false,
  }))
  .on(claimFail, (state, payload) => ({
    ...state,
    isLoading: false,
    errors: payload,
  }));

reducer.on(setShowResubscribeModal, (state, payload) => ({
  ...state,
  showResubscribeModal: payload,
}));

export default reducer;
